/* Multimax 29 años | 2 x 1 y Bono inmediato en la página de producto y en el Smart Cart de Rebuy.
   Se carga en todas las páginas (layout/theme.liquid, snippet mx29-2x1-config) y lee su configuración de
   window.MX29_2X1 = { url: '/pages/aniversario', tpl: 'template--…__' }.

   Qué productos son 2 x 1 y cuándo: los bloques Producto con tipo "2 x 1" de la Venta exclusiva de la landing
   (carrusel y "Promos del día"), solo mientras su día está en curso (hora de inicio → 8:00 a.m. del día siguiente).
   La lista se lee con la Section Rendering API (?sections=) y se guarda 10 minutos en el navegador.

   - Página de producto: avisos [data-mx29-2x1] (snippet mx29-2x1-producto) y [data-mx29-bono-box]
     (snippet mx29-bono-producto: monto del bono y vigencia; el precio con el bono solo se ve en el carrito).
   - Smart Cart, bono inmediato: confirma "Bono inmediato aplicado: −$xx" con el descuento que puso la app.
   - Regalía con producto (bloque Producto → "Producto de la regalía"): la página del producto muestra un checkbox
     (marcado por defecto) y, al agregar el producto, agrega también el regalo con Rebuy (snippet mx29-regalia-producto).
     Un regalo por carrito: si ya está en el carrito, no se agrega otro y el aviso dice "Tu regalo ya está en el carrito".
   - Cintillo [data-mx29-strip] debajo del breadcrumb (snippet mx29-cintillo) en todos los productos de la Venta exclusiva
     del día en curso (bloques Producto y Colección), con la cuenta regresiva al cierre y enlace a la landing.
   - "Complétalo" (bloque Producto → "Ofrecer con los televisores", ej. la barra de sonido): en la página de los televisores
     [data-mx29-xsell-box] (snippet mx29-xsell-tv) mientras el día está en curso. A los televisores de la Venta exclusiva
     de ese día se les ofrece en el Smart Cart, debajo de la línea del televisor.
   - Smart Cart: la app de descuento (ANIVERSARIO29) pone la unidad gratis en una línea aparte a $0.00.
     Con unidades sin pareja se sugiere "Agrega otra y te la llevas gratis" (+ botón); con el 2 x 1 aplicado,
     la línea gratis dice "¡Gratis con el 2 x 1!" y la pagada "2 x 1 aplicado". */
(function () {
  if (window.MX29_2X1_INIT) return;
  window.MX29_2X1_INIT = true;
  var cfg = window.MX29_2X1 || {}, url = cfg.url || '/pages/aniversario', tpl = cfg.tpl || '';
  if (!tpl || !window.fetch || !window.DOMParser) return;
  var KEY = 'mx29-promos4:' + url, TTL = 6e5;
  var keys = ['exclusivas', 'promos_1013', 'promos_1015', 'promos_1020', 'promos_1022', 'promos_1029', 'promos_1030', 'promos_1031'];

  /* ───── Lista de 2 x 1 por día ───── */
  function tzMin(v) { var m = /^([+-])(\d{2})(\d{2})$/.exec(v || ''); return m ? (m[1] === '-' ? -1 : 1) * (+m[2] * 60 + +m[3]) : -300; }
  function at(ymd, tz, addDays, h) { return Date.UTC(ymd[0], ymd[1] - 1, ymd[2] + addDays, h, 0) - tz * 60000; }
  function num(v, d) { return v !== undefined && v !== '' && isFinite(+v) ? +v : d; }
  function load() {
    var groups = [keys.slice(0, 5), keys.slice(5)];
    return Promise.all(groups.map(function (g) {
      var ids = g.map(function (k) { return tpl + k; }).join(',');
      return fetch(url + '?sections=' + encodeURIComponent(ids)).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; });
    })).then(function (parts) {
      var all = Object.assign.apply(null, [{}].concat(parts)), parser = new DOMParser(), byDate = {}, days = [];
      var exc = all[tpl + 'exclusivas'] && parser.parseFromString(all[tpl + 'exclusivas'], 'text/html').querySelector('[data-mx29-exc]');
      if (!exc) return null;                                          // falló la consulta o la sección está apagada: no se guarda
      var tz = tzMin(exc.dataset.mx29Tz), s0 = num(exc.dataset.mx29Start, 9), e0 = num(exc.dataset.mx29End, 8);
      var slides = exc.querySelectorAll('.xs'), tabs = exc.querySelectorAll('.xtab');
      Array.prototype.forEach.call(slides, function (s, i) {
        var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec((s.dataset.mx29Date || '').trim()); if (!m) return;
        var ymd = [+m[1], +m[2], +m[3]], d = { date: s.dataset.mx29Date.trim(), tz: tz, start: at(ymd, tz, 0, num(s.dataset.mx29Start, s0)), end: at(ymd, tz, 1, e0),
          branches: tabs[i] && tabs[i].querySelector('span') ? tabs[i].querySelector('span').textContent.trim() : '', handles: [], bonos: {}, gifts: {}, all: [], colls: [], xsell: [] };
        byDate[d.date] = d; days.push(d);
      });
      var add = function (root) {
        Array.prototype.forEach.call(root.querySelectorAll('.xpc[data-mx29-handle]'), function (c) {
          var p = c.closest('[data-mx29-date]'), d = p && byDate[(p.dataset.mx29Date || '').trim()], h = c.dataset.mx29Handle;
          if (!d) return;
          if (d.all.indexOf(h) < 0) d.all.push(h);                         // todos los productos del día (cintillo)
          if (c.hasAttribute('data-mx29-xsell') && d.xsell.indexOf(h) < 0) d.xsell.push(h);   // se ofrece con los televisores
          if (c.dataset.mx29Promo === '2x1' && d.handles.indexOf(h) < 0) d.handles.push(h);
          // Bono inmediato: monto en centavos (data-mx29-bono) o, si no está, el texto de la etiqueta
          var bono = +c.dataset.mx29Bono || 0, el = c.querySelector('.xbono b');
          if (!bono && el) bono = Math.round(parseFloat(el.textContent.replace(/[^\d.]/g, '')) * 100) || 0;
          if (bono > 0) d.bonos[h] = Math.max(d.bonos[h] || 0, bono);
          // Regalía con producto (Microsoft 365, etc.): { producto de la regalía, texto }
          if (c.dataset.mx29Gift) d.gifts[h] = { product: c.dataset.mx29Gift, text: c.dataset.mx29GiftText || '' };
        });
        // Bloques Colección: sus productos también llevan el cintillo
        Array.prototype.forEach.call(root.querySelectorAll('.xcol[data-mx29-coll]'), function (c) {
          var p = c.closest('[data-mx29-date]'), d = p && byDate[(p.dataset.mx29Date || '').trim()];
          if (d && d.colls.indexOf(c.dataset.mx29Coll) < 0) d.colls.push(c.dataset.mx29Coll);
        });
      };
      add(exc);
      keys.slice(1).forEach(function (k) { if (all[tpl + k]) add(parser.parseFromString(all[tpl + k], 'text/html')); });
      return days.filter(function (d) { return d.all.length || d.colls.length; });
    });
  }
  var pending = null, failedAt = 0;
  function getDays() {
    try { var c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (c && Date.now() - c.t < TTL) return Promise.resolve(c.days); } catch (e) {}
    if (Date.now() - failedAt < 6e4) return Promise.resolve([]);       // falló hace menos de 1 minuto: no se insiste
    if (!pending) pending = load().then(function (days) {
      pending = null;
      if (!days) { failedAt = Date.now(); return []; }                  // sin datos: se reintenta en la próxima revisión
      try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), days: days })); } catch (e) {}
      return days;
    }, function () { pending = null; return []; });
    return pending;
  }
  // Día en curso en el que el producto es 2 x 1 (o null)
  function activeDay(days, handle) {
    var now = Date.now();
    for (var i = 0; i < days.length; i++) if (days[i].handles.indexOf(handle) >= 0 && now >= days[i].start && now < days[i].end) return days[i];
    return null;
  }
  function activeBono(days, handle) {
    var now = Date.now();
    for (var i = 0; i < days.length; i++) { var b = days[i].bonos && days[i].bonos[handle]; if (b && now >= days[i].start && now < days[i].end) return { day: days[i], amount: b }; }
    return null;
  }
  function activeGift(days, handle) {
    var now = Date.now();
    for (var i = 0; i < days.length; i++) { var g = days[i].gifts && days[i].gifts[handle]; if (g && now >= days[i].start && now < days[i].end) return { day: days[i], gift: g }; }
    return null;
  }
  // Productos de regalía de los días en curso (para marcar sus líneas en el carrito)
  function activeGiftProducts(days) {
    var now = Date.now(), out = {};
    days.forEach(function (d) { if (now >= d.start && now < d.end) Object.keys(d.gifts || {}).forEach(function (h) { out[d.gifts[h].product] = d.gifts[h]; }); });
    return out;
  }
  var money = function (c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  function endTxt(d) {
    var t = new Date(d.end + d.tz * 60000), h = t.getUTCHours(), mi = String(t.getUTCMinutes()).padStart(2, '0');
    var day = t.toLocaleDateString('es-PA', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).replace(',', '');
    return 'Válido hasta las ' + (h % 12 || 12) + ':' + mi + (h < 12 ? ' a.m.' : ' p.m.') + ' del ' + day + ' en multimax.net' + (d.branches ? ' y ' + d.branches : '') + '.';
  }

  /* ───── Stock de las variantes de un producto (sección mx29-2x1-stock / snippet mx29-2x1-stock-json) ─────
     El 2 x 1 aplica entre variantes del mismo producto. Para que el pedido avance, cada variante debe tener stock en
     Shopify y todas las unidades deben estar en una misma bodega (un pedido repartido no pasa el checkout). */
  var stockMem = {}, SKEY = 'mx29-2x1-stock:', STTL = 12e4;
  function getProductStock(handle) {
    if (stockMem[handle]) return stockMem[handle];
    try { var c = JSON.parse(sessionStorage.getItem(SKEY + handle) || 'null'); if (c && Date.now() - c.t < STTL) return (stockMem[handle] = Promise.resolve(c.s)); } catch (e) {}
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    stockMem[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=mx29-2x1-stock').then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mx29-stock]'), st = null;
      try { st = el ? JSON.parse(el.textContent) : null; } catch (e) {}
      if (st && Object.keys(st).length) { try { sessionStorage.setItem(SKEY + handle, JSON.stringify({ t: Date.now(), s: st })); } catch (e) {} }
      return st;
    }).catch(function () { return null; });
    setTimeout(function () { delete stockMem[handle]; }, STTL);
    return stockMem[handle];
  }
  // need = { variantId: unidades } → ¿pueden ir todas en un mismo pedido?
  function canHold(stock, need) {
    if (!stock) return false;
    var ids = Object.keys(need), withLocs = [];
    for (var i = 0; i < ids.length; i++) {
      var v = stock[ids[i]], n = need[ids[i]];
      if (!v || v.available === false) return false;
      if (v.tracked && v.policy !== 'continue' && v.total < n) return false;     // inventario de Shopify
      if (v.locs && Object.keys(v.locs).length) withLocs.push(ids[i]);
    }
    if (!withLocs.length) return true;                                           // sin datos de bodega
    var whs = {};
    withLocs.forEach(function (id) { Object.keys(stock[id].locs).forEach(function (w) { whs[w] = 1; }); });
    return Object.keys(whs).some(function (w) {                                  // una bodega con todas las unidades
      return withLocs.every(function (id) { return (stock[id].locs[w] || 0) >= need[id]; });
    });
  }
  function plus(need, id, n) { var o = {}; Object.keys(need).forEach(function (k) { o[k] = need[k]; }); o[id] = (o[id] || 0) + n; return o; }
  // Otras variantes que completan el par con lo que ya hay
  function pairCandidates(stock, need, exceptId) {
    return Object.keys(stock || {}).filter(function (id) { return String(id) !== String(exceptId) && canHold(stock, plus(need, id, 1)); });
  }
  function joinNames(arr) { return arr.length < 2 ? arr.join('') : arr.slice(0, -1).join(', ') + ' o ' + arr[arr.length - 1]; }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ───── Página de producto ───── */
  function currentVariant(box) {
    var vs = document.querySelector('variant-selection'), v = vs && vs.getAttribute('variant');
    if (v && /^\d+$/.test(v)) return v;
    var q = new URLSearchParams(location.search).get('variant');
    return q || box.dataset.variant;
  }
  function productBadges() {
    var boxes = document.querySelectorAll('[data-mx29-2x1]'); if (!boxes.length) return;
    getDays().then(function (days) {
      Array.prototype.forEach.call(boxes, function (box) {
        var d = activeDay(days, box.dataset.handle), stock = null, vid = currentVariant(box), note = '';
        try { stock = JSON.parse(box.dataset.stock || 'null'); } catch (e) {}
        var ok = !!d;
        if (d && stock && stock[vid]) {
          if (!canHold(stock, plus({}, vid, 2))) {                                  // este color solo no alcanza
            var alt = (stock[vid].available !== false) ? pairCandidates(stock, plus({}, vid, 1), vid) : [];
            ok = alt.length > 0;
            if (ok) note = 'Combínalo con ' + joinNames(alt.map(function (id) { return stock[id].title; })) + ' y paga solo 1. ';
          }
        }
        box.hidden = !ok;
        if (ok) box.querySelector('[data-mx29-2x1-when]').textContent = note + endTxt(d);
      });
    });
  }
  // Bono inmediato: monto y vigencia mientras el día está en curso. El precio con el bono solo se ve en el carrito.
  function productBonos() {
    var boxes = document.querySelectorAll('[data-mx29-bono-box]'); if (!boxes.length) return;
    getDays().then(function (days) {
      Array.prototype.forEach.call(boxes, function (box) {
        var b = activeBono(days, box.dataset.handle), avail = {};
        try { avail = JSON.parse(box.dataset.avail || '{}'); } catch (e) {}
        var vid = currentVariant(box), v = avail[vid];
        var ok = !!b && (!v || v.available !== false);
        box.hidden = !ok;
        if (!ok) return;
        box.querySelector('[data-mx29-bono-amount]').textContent = money(b.amount);
        box.querySelector('[data-mx29-bono-when]').textContent = endTxt(b.day);
      });
    });
  }
  // Regalía: aviso con checkbox (marcado por defecto). Si está marcado, al agregar el producto se agrega también el regalo.
  var giftInfo = {};
  function giftProduct(handle) {
    if (!giftInfo[handle]) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      giftInfo[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return giftInfo[handle];
  }
  function cartJs() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  // Unidades del producto de regalo en el carrito (cualquier variante, gratis o no)
  function giftUnits(cart, giftId) {
    return (cart && cart.items || []).reduce(function (n, it) { return n + (String(it.product_id) === String(giftId) ? it.quantity : 0); }, 0);
  }
  // Un regalo por carrito: si ya está, se cambia el checkbox por el aviso "Tu regalo ya está en el carrito"
  function setGiftInCart(box, inCart) {
    box.dataset.giftInCart = inCart ? '1' : '';
    var ask = box.querySelector('[data-mx29-gift-ask]'), has = box.querySelector('[data-mx29-gift-has]');
    if (ask) ask.hidden = inCart;
    if (has) has.hidden = !inCart;
  }
  function productGifts() {
    var boxes = document.querySelectorAll('[data-mx29-gift-box]'); if (!boxes.length) return;
    var cartP = cartJs().catch(function () { return null; });
    getDays().then(function (days) {
      Array.prototype.forEach.call(boxes, function (box) {
        var g = activeGift(days, box.dataset.handle), avail = {};
        try { avail = JSON.parse(box.dataset.avail || '{}'); } catch (e) {}
        var v = avail[currentVariant(box)];
        if (!g || (v && v.available === false)) { box.hidden = true; box.dataset.giftVariant = ''; return; }
        Promise.all([giftProduct(g.gift.product), cartP]).then(function (r) {
          var gp = r[0], cart = r[1];
          var gv = gp && (gp.variants.filter(function (x) { return x.available; })[0]);
          var inCart = !!(gp && giftUnits(cart, gp.id));
          if (!gv && !inCart) { box.hidden = true; box.dataset.giftVariant = ''; return; }
          box.dataset.giftVariant = gv ? gv.id : '';
          box.dataset.giftProduct = gp.id;
          setGiftInCart(box, inCart);
          box.querySelector('[data-mx29-gift-name]').textContent = g.gift.text || gp.title;
          var img = box.querySelector('[data-mx29-gift-img]');
          if (img && gp.featured_image) { img.src = gp.featured_image + (gp.featured_image.indexOf('?') < 0 ? '?' : '&') + 'width=120'; img.alt = gp.title; img.hidden = false; }
          box.querySelector('[data-mx29-gift-when]').textContent = endTxt(g.day);
          box.hidden = false;
        });
      });
    });
  }
  // Al presionar "Agregar al carrito" (o el botón del aviso de bono) con el checkbox marcado: cuando el producto ya
  // está en el carrito, se agrega el regalo con Rebuy (propiedad oculta _mx29_regalo) para que el Smart Cart se actualice.
  function addGiftAfter(productVariant, giftVariant, giftId, handle) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', tries = 0;
    (function poll() {
      cartJs().then(function (cart) {
        var main = 0;
        cart.items.forEach(function (it) { if (String(it.variant_id) === String(productVariant)) main += it.quantity; });
        if (!main) { if (++tries < 16) setTimeout(poll, 500); return; }
        if (giftUnits(cart, giftId)) return productGifts();              // un regalo por carrito: ya lo tiene
        var item = { id: +giftVariant, quantity: 1, properties: { _mx29_regalo: handle } }, done;
        if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.addItem === 'function') done = Promise.resolve(Rebuy.Cart.addItem(item));
        else done = fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) });
        done.then(function () { setTimeout(productGifts, 1200); }, function () {});
      }).catch(function () {});
    })();
  }
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('form[action*="/cart/add"] button[name="add"]'); if (!add) return;
    var box = document.querySelector('[data-mx29-gift-box]:not([hidden])'), chk = box && box.querySelector('[data-mx29-gift-check]');
    if (!box || !chk || !chk.checked || !box.dataset.giftVariant || box.dataset.giftInCart) return;
    var form = add.closest('form'), idInput = form && form.querySelector('[name="id"]');
    var pv = (idInput && idInput.value) || currentVariant(box);
    setTimeout(function () { addGiftAfter(pv, box.dataset.giftVariant, box.dataset.giftProduct, box.dataset.handle); }, 300);
  }, true);

  // "Agregar al carrito y ver mi bono": usa el botón de compra del tema
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mx29-bono-add]'); if (!b) return;
    var add = document.querySelector('form[action*="/cart/add"] button[name="add"]');
    if (add && !add.disabled) { e.preventDefault(); add.click(); }
  });

  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-selection')) setTimeout(function () { productBadges(); productBonos(); productGifts(); }, 50); }, true);

  // "Complétalo": productos que se ofrecen con los televisores en el día en curso → { day, products: [producto .js disponibles] }
  function activeXsell(days) {
    var now = Date.now(), d = null;
    for (var i = 0; i < days.length && !d; i++) if ((days[i].xsell || []).length && now >= days[i].start && now < days[i].end) d = days[i];
    if (!d) return Promise.resolve(null);
    return Promise.all(d.xsell.map(giftProduct)).then(function (ps) {
      ps = ps.filter(function (p) { return p && p.available; });
      return ps.length ? { day: d, products: ps } : null;
    });
  }
  function xsVariant(p) { return p.variants.filter(function (v) { return v.available; })[0] || p.variants[0]; }
  function shortTitle(t) { return String(t).split('|')[0].trim(); }
  function productXsell() {
    var boxes = document.querySelectorAll('[data-mx29-xsell-box]'); if (!boxes.length) return;
    var cartP = cartJs().catch(function () { return null; });
    getDays().then(activeXsell).then(function (ax) {
      return cartP.then(function (cart) {
        Array.prototype.forEach.call(boxes, function (box) {
          var h = box.dataset.handle;
          // Sin oferta del día, o televisor de la Venta exclusiva (a ese se le ofrece en el Smart Cart)
          if (!ax || ax.day.all.indexOf(h) >= 0) { box.hidden = true; box.dataset.on = ''; return; }
          var ps = ax.products.filter(function (p) { return p.handle !== h; });
          if (!ps.length) { box.hidden = true; box.dataset.on = ''; return; }
          var html = ps.map(function (p) {
            var v = xsVariant(p), inCart = (cart && cart.items || []).some(function (it) { return String(it.product_id) === String(p.id); });
            var src = p.featured_image ? String(p.featured_image).replace(/^\/\//, 'https://') : '';
            var img = src ? '<img src="' + esc(src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=160') + '" alt="" width="64" height="64" loading="lazy">' : '';
            return '<li class="mx29-xs__item">' + img + '<div class="mx29-xs__info"><a class="mx29-xs__name" href="/products/' + encodeURIComponent(p.handle) + '">' + esc(shortTitle(p.title)) + '</a>' +
              '<span class="mx29-xs__price"><b>' + money(v.price) + '</b>' + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '</span></div>' +
              (inCart ? '<span class="mx29-xs__in">✓ En tu carrito</span>' : '<button type="button" class="mx29-xs__btn" data-mx29-xsell-add="' + v.id + '">Agregar también</button>') + '</li>';
          }).join('');
          var list = box.querySelector('[data-mx29-xsell-list]'); if (list.innerHTML !== html) list.innerHTML = html;
          box.querySelector('[data-mx29-xsell-when]').textContent = 'Precio especial v' + endTxt(ax.day).slice(1);
          box.dataset.on = '1'; box.hidden = false;
        });
      });
    });
  }
  // "Agregar" de "Complétalo" (página del televisor y Smart Cart): con Rebuy para que el Smart Cart se actualice
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mx29-xsell-add]'); if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    b.disabled = true; b.textContent = 'Agregando…';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', item = { id: +b.dataset.mx29XsellAdd, quantity: 1 }, inCart = !!b.closest('#rebuy-cart'), done;
    if (window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.addItem === 'function') done = Promise.resolve(Rebuy.Cart.addItem(item));
    else done = fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) });
    done.then(function () {
      if (!inCart && window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function') setTimeout(function () { Rebuy.SmartCart.show(); }, 400);
      setTimeout(productXsell, 1200);
    }, function () { b.disabled = false; b.textContent = inCart ? '+ Agregar' : 'Agregar también'; });
  });

  // Cintillo: producto de la Venta exclusiva del día en curso → cuenta regresiva al cierre y enlace a la landing
  var stripTimer = 0;
  function pad(n) { return String(n).padStart(2, '0'); }
  function tickStrips() {
    var on = 0;
    Array.prototype.forEach.call(document.querySelectorAll('[data-mx29-strip]:not([hidden])'), function (box) {
      var left = Math.floor((+box.dataset.end - Date.now()) / 1000);
      if (left <= 0) { box.hidden = true; return; }                     // terminó la venta: se oculta
      on++;
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), sec = left % 60;
      var html = (d ? '<i>' + d + '</i>d ' : '') + '<i>' + pad(h) + '</i>h <i>' + pad(m) + '</i>m <i>' + pad(sec) + '</i>s';
      var el = box.querySelector('[data-mx29-strip-cd]'); if (el.innerHTML !== html) el.innerHTML = html;
    });
    if (!on) { clearInterval(stripTimer); stripTimer = 0; }
  }
  function productStrips() {
    var boxes = document.querySelectorAll('[data-mx29-strip]'); if (!boxes.length) return;
    getDays().then(function (days) {
      var now = Date.now();
      Array.prototype.forEach.call(boxes, function (box) {
        var colls = (box.dataset.colls || '').split(','), day = null;
        for (var i = 0; i < days.length && !day; i++) {
          var d = days[i];
          if (now >= d.start && now < d.end && (d.all.indexOf(box.dataset.handle) >= 0 || (d.colls || []).some(function (c) { return colls.indexOf(c) >= 0; }))) day = d;
        }
        if (!day) { box.hidden = true; return; }
        box.dataset.end = day.end;
        var a = box.querySelector('[data-mx29-strip-link]'); if (a) a.href = url + '#exclusivas';
        box.hidden = false;
      });
      tickStrips();
      if (!stripTimer && document.querySelector('[data-mx29-strip]:not([hidden])')) stripTimer = setInterval(tickStrips, 1000);
    });
  }

  /* ───── Smart Cart de Rebuy ───── */
  var cartBusy = false;
  function isFree(it) { return it && it.final_line_price === 0 && (it.line_level_discount_allocations || []).length > 0; }
  function setMsg(li, kind, html) {
    var info = li.querySelector('.rebuy-cart__flyout-item-info'); if (!info) return;
    var el = info.querySelector('.mx29-cart-2x1');
    if (!kind) { if (el) el.remove(); return; }
    if (el && el.dataset.kind === kind && el.dataset.html === html) return; // ya está: evita bucles con el observador
    if (!el) { el = document.createElement('div'); info.appendChild(el); }
    el.className = 'mx29-cart-2x1 mx29-cart-2x1--' + kind; el.dataset.kind = kind; el.dataset.html = html; el.innerHTML = html;
  }
  function setXs(li, html) {
    var info = li.querySelector('.rebuy-cart__flyout-item-info'); if (!info) return;
    var el = info.querySelector('.mx29-cart-xs');
    if (!html) { if (el) el.remove(); return; }
    if (el && el.dataset.html === html) return;
    if (!el) { el = document.createElement('div'); el.className = 'mx29-cart-xs'; info.appendChild(el); }
    el.dataset.html = html; el.innerHTML = html;
  }
  // Televisor de la Venta exclusiva en el carrito y sin el producto de "Complétalo": se ofrece debajo de su línea
  function decorateXsell(days, items, lis) {
    activeXsell(days).then(function (ax) {
      var tv = -1, have = {};
      items.forEach(function (it) { have[it.handle] = 1; });
      var ps = ax ? ax.products.filter(function (p) { return !have[p.handle]; }) : [];
      if (ps.length) items.forEach(function (it, i) { if (tv < 0 && ax.day.all.indexOf(it.handle) >= 0 && it.product_type === 'Televisores') tv = i; });
      Array.prototype.forEach.call(lis, function (li, i) {
        if (!li.isConnected) return;
        if (i !== tv) return setXs(li, null);
        setXs(li, ps.map(function (p) {
          var v = xsVariant(p);
          return '<span class="mx29-cart-2x1__tag">COMPLÉTALO</span> <span>Agrega <b>' + esc(shortTitle(p.title)) + '</b> a <b>' + money(v.price) + '</b>' +
            (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '') + '</span>' +
            '<button type="button" class="mx29-cart-2x1__btn" data-mx29-xsell-add="' + v.id + '">+ Agregar</button>';
        }).join(''));
      });
    });
  }
  function decorateCart() {
    var S = window.Rebuy && Rebuy.SmartCart, root = document.getElementById('rebuy-cart');
    if (!S || !root || typeof S.items !== 'function') return;
    var items = S.items() || [], lis = root.querySelectorAll('.rebuy-cart__flyout-item');
    if (!items.length || items.length !== lis.length) return;
    getDays().then(function (days) {
      // Unidades pagadas y gratis por producto
      var tally = {};
      items.forEach(function (it) {
        var t = tally[it.handle] || (tally[it.handle] = { paid: 0, free: 0 });
        if (isFree(it)) t.free += it.quantity; else t.paid += it.quantity;
      });
      var giftHandles = activeGiftProducts(days), giftQty = {};
      items.forEach(function (it) { if ((it.properties && it.properties._mx29_regalo) || giftHandles[it.handle]) giftQty[it.handle] = (giftQty[it.handle] || 0) + it.quantity; });
      var lis2 = root.querySelectorAll('.rebuy-cart__flyout-item'); if (lis2.length !== items.length) return;
      decorateXsell(days, items, lis2);
      items.forEach(function (it, i) {
        var li = lis2[i], t = tally[it.handle], promo = activeDay(days, it.handle);
        // Regalía: la línea del regalo (agregada desde la página del producto o que coincide con un regalo del día)
        var isGiftLine = (it.properties && it.properties._mx29_regalo) || giftHandles[it.handle];
        if (isGiftLine && it.final_line_price === 0) return setMsg(li, 'free', '<b>¡Regalo con tu compra!</b>');
        if (isGiftLine && giftQty[it.handle] > 1) return setMsg(li, 'note', 'La promoción incluye un regalo por compra: las unidades adicionales tienen su precio regular.');
        if (it.properties && it.properties._mx29_regalo) return setMsg(li, 'note', 'Este regalo es gratis solo junto con el producto de la promoción.');
        // 2 x 1: solo productos que hoy son 2 x 1 en la Venta exclusiva (otras promos también ponen líneas a $0.00)
        if (promo && isFree(it)) return setMsg(li, 'free', '<b>¡Gratis con el 2 x 1!</b>');
        // Bono inmediato: confirma el descuento que puso la app en esta línea
        var bono = activeBono(days, it.handle), disc = (it.line_level_discount_allocations || []).reduce(function (n, x) { return n + (x.amount || 0); }, 0);
        if (bono && !promo && disc > 0) return setMsg(li, 'bono', '<span class="mx29-cart-2x1__tag">BONO</span> Bono inmediato aplicado: <b>−' + money(disc) + '</b>');
        if (!promo) return setMsg(li, null);
        var ok = '<span class="mx29-cart-2x1__tag">2 x 1</span> Aplicado: te llevas ' + (t.paid + t.free) + ' y pagas ' + t.paid + '.';
        if (t.free > 0 && t.paid <= t.free) return setMsg(li, 'ok', ok);
        var vid = it.variant_id, need = {};
        items.forEach(function (x) { if (x.handle === it.handle) need[x.variant_id] = (need[x.variant_id] || 0) + x.quantity; });
        return getProductStock(it.handle).then(function (stock) {
          if (!li.isConnected) return;
          if (canHold(stock, plus(need, vid, 1)))                                  // otra unidad del mismo color
            return setMsg(li, 'add', '<span class="mx29-cart-2x1__tag">2 x 1</span> Agrega otra y te la llevas gratis. <button type="button" class="mx29-cart-2x1__btn" data-mx29-add-one data-handle="' + esc(it.handle) + '">+ Agregar otra</button>');
          var alt = pairCandidates(stock, need, vid);                               // o de otro color del mismo producto
          if (alt.length) {
            var names = joinNames(alt.map(function (id) { return esc(stock[id].title); }));
            var href = '/products/' + encodeURIComponent(it.handle) + '?variant=' + alt[0];
            return setMsg(li, 'alt', '<span class="mx29-cart-2x1__tag">2 x 1</span> Este color no tiene otra unidad. Combínalo con ' + names + ' y paga solo 1. <a class="mx29-cart-2x1__btn" href="' + href + '">Ver colores</a>');
          }
          setMsg(li, null);
        });
      });
    });
  }
  // "+ Agregar otra": usa el botón "+" de Rebuy de esa línea
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mx29-add-one]'); if (!b) return;
    e.preventDefault();
    var li = b.closest('.rebuy-cart__flyout-item'), btns = li && li.querySelectorAll('.rebuy-cart__flyout-item-quantity-widget-button');
    if (!btns || !btns[1]) return;
    b.disabled = true; b.textContent = 'Agregando…'; btns[1].click();
    setTimeout(function () {
      if (!b.isConnected || !b.disabled) return;                       // ya se redibujó: se agregó
      var box = b.closest('.mx29-cart-2x1'); if (!box) return;
      box.className = 'mx29-cart-2x1 mx29-cart-2x1--note'; box.dataset.kind = 'note'; box.dataset.html = '';
      box.textContent = 'No hay otra unidad disponible de este producto.';
      try { sessionStorage.removeItem(SKEY + b.dataset.handle); } catch (e) {}
      delete stockMem[b.dataset.handle];
    }, 6000);
  });
  var t = 0;
  function schedule() { clearTimeout(t); t = setTimeout(decorateCart, 150); giftsSoon(); }
  function watchCart() {
    var root = document.getElementById('rebuy-cart');
    if (!root) return false;
    new MutationObserver(function (muts) {
      // Ignora los cambios que hace este mismo script
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target; if (!(n.closest && n.closest('.mx29-cart-2x1, .mx29-cart-xs'))) return schedule();
      }
    }).observe(root, { childList: true, subtree: true, characterData: true });
    schedule();
    return true;
  }
  ['rebuy:cart.change', 'rebuy:smartcart.show', 'rebuy:smartcart.ready', 'rebuy.ready'].forEach(function (ev) { document.addEventListener(ev, schedule); });
  // El aviso de regalo sigue al carrito (si el cliente quita el regalo, vuelve el checkbox)
  var tg = 0;
  function giftsSoon() {
    var g = document.querySelector('[data-mx29-gift-box][data-gift-product]'), x = document.querySelector('[data-mx29-xsell-box][data-on="1"]');
    if (!g && !x) return;
    clearTimeout(tg); tg = setTimeout(function () { if (g) productGifts(); if (x) productXsell(); }, 600);
  }

  function boot() {
    productBadges(); productBonos(); productGifts(); productStrips(); productXsell();
    setInterval(function () { productBadges(); productBonos(); productGifts(); productStrips(); productXsell(); }, 60000);
    if (!watchCart()) { var tries = 0, iv = setInterval(function () { if (watchCart() || ++tries > 40) clearInterval(iv); }, 500); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
